import React from 'react';
import { connect } from 'react-redux';
import Header from '../layout/Header';
import Message from '../layout/Message';
import Button from '../layout/Button';
import FormField from '../layout/FormField';

import {
    fetchPianoTechUserList,
    RETURN_TO_PIANOTECHUSER_LIST,
    SWITCH_EDIT_TYPE,
    PIANOTECHUSER_MODIFIED,
    SAVE_PIANOTECHUSER_STARTED,
    savePianoTechUser,
    PIANOTECHUSER_VALIDATE,
} from '../../actions/PianoTechUserActions';

import {
    MAINTENANCE_TYPE_VIEW,
    MAINTENANCE_TYPE_EDIT,
    MAINTENANCE_TYPE_ADD,
    MAINTENANCE_TYPE_COMPLETE,
    MAINTENANCE_TYPE_DELETE,
    uiFieldInfoPianoTechUser,
    MESSAGE_TYPE_INFO,
    MESSAGE_TYPE_ERROR,
} from '../../app-constants';

import {
    validateForm,
    checkForChanges,
} from '../../utilities/validate';

const mapStateToProps = state => ({
    pianoTechUser: state.pianoTechUser,
    user: state.user,
});

class PianoTechUser extends React.PureComponent {

    returnToList = () => {

        if (this.props.pianoTechUser.maintenanceType === MAINTENANCE_TYPE_COMPLETE)
            this.props.dispatch(fetchPianoTechUserList());

        this.props.dispatch({
            type: RETURN_TO_PIANOTECHUSER_LIST
        })
    }

    onCancelClose = () => {

        switch (this.props.pianoTechUser.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
            case MAINTENANCE_TYPE_EDIT: {
                //Back to View Mode - restore original 
                const pianoTechUser = Object.assign({}, this.props.pianoTechUser.originalPianoTechUser);
                this.props.dispatch({
                    type: SWITCH_EDIT_TYPE,
                    maintenanceType: MAINTENANCE_TYPE_VIEW,
                    title: "View PianoTechUser",
                    pianoTechUser,
                });

                break;
            }

            default:
                this.returnToList();
        }
    }

    editPianoTechUser = () => {
        const pianoTechUser = this.props.pianoTechUser.pianoTechUser;
        this.props.dispatch({
            type: SWITCH_EDIT_TYPE,
            maintenanceType: MAINTENANCE_TYPE_EDIT,
            title: "Edit PianoTechUser",
            pianoTechUser,
        });
    }

    onDelete = () => {
        switch (this.props.pianoTechUser.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
                this.saveAction();
                break;

            default:
                const pianoTechUser = this.props.pianoTechUser.pianoTechUser;
                this.props.dispatch({
                    type: SWITCH_EDIT_TYPE,
                    maintenanceType: MAINTENANCE_TYPE_DELETE,
                    title: "Delete PianoTechUser",
                    pianoTechUser,
                });
        }
    }

    saveAction = () => {
        let message = '';

        switch (this.props.pianoTechUser.maintenanceType) {
            case MAINTENANCE_TYPE_EDIT:
                message = 'Saving PianoTechUser';
                break;
            case MAINTENANCE_TYPE_DELETE:
                message = 'Deleting PianoTechUser';
                break;
            case MAINTENANCE_TYPE_ADD:
                message = 'Adding PianoTechUser';
                break;

            default:

        }

        this.props.dispatch({
            type: SAVE_PIANOTECHUSER_STARTED,
            message,
        })

        const { pianoTechUser } = this.props.pianoTechUser;
        pianoTechUser.maintenanceType = this.props.pianoTechUser.maintenanceType;
        this.props.dispatch(savePianoTechUser(pianoTechUser));
    }

    onChange = (e) => {
        const fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (e.target.type === 'checkbox') {
            fieldValue = e.target.checked;
        }

        const { pianoTechUser } = this.props.pianoTechUser;
        pianoTechUser[fieldName] = fieldValue;

        this.props.dispatch({
            type: PIANOTECHUSER_MODIFIED,
            pianoTechUser,
        })

    }

    formValid = () => {
        const { pianoTechUser, maintenanceType } = this.props.pianoTechUser;
        const validFormInfo = validateForm(uiFieldInfoPianoTechUser, pianoTechUser, maintenanceType);

        return validFormInfo.valid;
    }

    validate = () => {
        const { pianoTechUser, maintenanceType } = this.props.pianoTechUser;
        const validInfo = validateForm(uiFieldInfoPianoTechUser, pianoTechUser, maintenanceType);

        let message = '';
        let messageType = MESSAGE_TYPE_ERROR;

        if (validInfo.errors.length > 0) {
            validInfo.errors.map((err) => {
                message += err;
                return '';
            });
        } else {
            messageType = MESSAGE_TYPE_INFO;
            validInfo.info.map((info) => {
                message += info;
                return '';
            });
        }

        this.props.dispatch({
            type: PIANOTECHUSER_VALIDATE,
            message,
            messageType,
        })
    }

    checkForChanges = () => {
        const { pianoTechUser, originalPianoTechUser, maintenanceType } = this.props.pianoTechUser

        if (!this.formValid())
            return false;

        if (maintenanceType === 'add') {
            return true;
        }

        return checkForChanges(uiFieldInfoPianoTechUser, pianoTechUser, originalPianoTechUser)

    }

    render() {
        const { pianoTechUser } = this.props.pianoTechUser;
        const { user } = this.props;

        const notAdminUser = !user.adminUser;

        let showSave = false, showDelete = false, cancelCloseText = 'Cancel', showEdit = false,
            disabled = false, disableSave = false, deleteText = 'Delete';

        switch (this.props.pianoTechUser.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
                showDelete = true;
                disabled = true;
                deleteText = 'Confirm Delete';
                break;

            case MAINTENANCE_TYPE_COMPLETE:
                showSave = false;
                cancelCloseText = 'Close';
                disabled = true;
                break;

            case MAINTENANCE_TYPE_VIEW:
                showEdit = this.props.user.allowEdit;
                showDelete = this.props.user.allowDelete;
                disabled = true;
                cancelCloseText = 'Close';
                break;

            default:
                if (this.props.user.allowEdit)
                    showSave = true;

                disableSave = !this.checkForChanges();
        }

        return (
            <div className="divMedium" align="center">
                <Header header2={this.props.pianoTechUser.title} />
                <Message message={this.props.pianoTechUser.message}
                    type={this.props.pianoTechUser.messageType} />
                <br />
                <table className='tableMedium'>
                    <tbody>
                        <tr>
                            <td>
                                <Button className="bluebutton" description="Return to List" onClick={this.returnToList} />
                            </td>
                            <td>
                            </td>
                        </tr>
                        {this.props.pianoTechUser.maintenanceType !== 'add' &&
                            <FormField row form={{ title: 'User Id', type: 'textinput', length: '10', maxLength: '10', disabled: true }}
                                name="userId"
                                value={pianoTechUser.userId}
                                onChange={this.onChange}
                            />
                        }
                        <FormField row form={{ title: 'Login Id', type: 'textinput', length: '80', maxLength: '80', disabled }}
                            name="loginId"
                            value={pianoTechUser.loginId}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Encrypted Password', type: 'textinput', length: '256', maxLength: '256', disabled }}
                            name="encryptedPassword"
                            value={pianoTechUser.encryptedPassword}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'User Name', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="userName"
                            value={pianoTechUser.userName}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'User Email', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="userEmail"
                            value={pianoTechUser.userEmail}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Company Id', type: 'textinput', length: '10', maxLength: '10', disabled: notAdminUser }}
                            name="companyId"
                            value={pianoTechUser.companyId}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Admin User', type: 'checkbox', disabled }}
                            name="adminUser"
                            value={pianoTechUser.adminUser}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Require New Password', type: 'checkbox', disabled }}
                            name="requireNewPassword"
                            value={pianoTechUser.requireNewPassword}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Locked Out', type: 'checkbox', disabled }}
                            name="lockedOut"
                            value={pianoTechUser.lockedOut}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Current Invalid Login Attempts', type: 'textinput', length: '10', maxLength: '10', disabled }}
                            name="currentInvalidLoginAttempts"
                            value={pianoTechUser.currentInvalidLoginAttempts}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Lifetime Invalid Login Attempts', type: 'textinput', length: '10', maxLength: '10', disabled }}
                            name="lifetimeInvalidLoginAttempts"
                            value={pianoTechUser.lifetimeInvalidLoginAttempts}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Last Login Ip Address', type: 'textinput', length: '50', maxLength: '50', disabled }}
                            name="lastLoginIpAddress"
                            value={pianoTechUser.lastLoginIpAddress}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Last Login', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="lastLogin"
                            value={pianoTechUser.lastLogin}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Last Invalid Login', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="lastInvalidLogin"
                            value={pianoTechUser.lastInvalidLogin}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Created', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="created"
                            value={pianoTechUser.created}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Last Updated', type: 'textinput', length: '0', maxLength: '0', disabled }}
                            name="lastUpdated"
                            value={pianoTechUser.lastUpdated}
                            onChange={this.onChange}
                        />
                        <tr>
                            <td>
                                {showEdit &&
                                    <Button className="bluebutton" description="Edit" onClick={this.editPianoTechUser} />
                                }
                                {showDelete &&
                                    <Button className="bluebutton" description={deleteText} onClick={this.onDelete} />
                                }
                                {showSave &&
                                    <div>
                                        <Button className="bluebutton" description="Save" disabled={disableSave} onClick={this.saveAction} />
                                        <Button className="bluebutton" description="Validate" onClick={this.validate} />
                                    </div>
                                }
                            </td>
                            <td>
                                <Button className="bluebutton" description={cancelCloseText} onClick={this.onCancelClose} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

}

export default connect(mapStateToProps)(PianoTechUser);
